import { useState } from "react";

import { DataFilter } from "interfaces";

import Modal from "ui-components/Modal";
import Button from "ui-components/Button";
import Divider from "ui-components/Divider";
import FilterSummary from "ui-components/Data-Filters/Filter-Summary";

import { useFetchDataFileStats } from "modules/data-files/api";
import FileFilters from "modules/data-files/elements/File-Filters";

import { useGetInputFile, useSuccessDef, useDropNulls } from "./store";

const SetSuccess = () => {
  const currentFile = useGetInputFile();
  const stats = useFetchDataFileStats(currentFile);

  const [showModal, setShowModal] = useState(false);

  const [successDef, setSuccessDef] = useSuccessDef();
  const nullsPresent = successDef
    ? successDef.filter((d) =>
        stats[d.column] ? stats[d.column].size > stats[d.column].count : false
      ).length >= 1
    : false;

  const [dropNulls, setDropNulls] = useDropNulls();

  const resetSuccessDef = () => setSuccessDef([]);

  const current = successDef;
  const [filters, setFilters] = useState<DataFilter.Filter[]>(successDef || []);

  const outer = (
    <div>
      {current.length >= 1 ? (
        <div>
          <p>
            Rows meeting ALL the below conditions are going to be treated as
            SUCCESS:
          </p>
          <ul className="list-decimal ml-2 pl-2 list-inside">
            {current.map((d, i) => (
              <li key={i} className="ml-2 pl-2">
                <FilterSummary filter={d} />
              </li>
            ))}
          </ul>
          {nullsPresent && (
            <div className="pt-2 flex items-center">
              <input
                type="checkbox"
                checked={dropNulls}
                onClick={() => setDropNulls(!dropNulls)}
              />
              <div className="pl-2 ml-2">
                <p>
                  The columns you selected to define the outcome have some
                  invalid values. Do you want to{" "}
                  <span className="font-semibold underline">
                    drop rows with invalid values?
                  </span>{" "}
                  If you decide not to drop, all of them will be{" "}
                  <span className="font-semibold">treated as FAILURE.</span>
                </p>
              </div>
            </div>
          )}
          <p className="mt-2">
            You want to delete/reset success definition?{" "}
            <span
              onClick={() => {
                resetSuccessDef();
                setShowModal(true);
              }}
              className="uppercase text-primary-main cursor-pointer underline"
            >
              Click here
            </span>
          </p>
        </div>
      ) : (
        <p className="text-center pt-2">
          <span
            className="underline text-primary-main cursor-pointer"
            onClick={() => setShowModal(true)}
          >
            Click here
          </span>{" "}
          to define the <span className="underline italic">success.</span>
        </p>
      )}
    </div>
  );

  const inner = (
    <div className="p-2 m-2">
      <FileFilters
        fileId={currentFile}
        title="Define Outcome Rules"
        filters={filters}
        updateFilters={setFilters}
      />
      <Divider />
      <div className="text-right">
        <Button color="gray" onClick={() => setShowModal(false)}>
          Exit without Saving
        </Button>
        <Button
          onClick={() => {
            setSuccessDef(filters);
            setShowModal(false);
          }}
        >
          Save
        </Button>
      </div>
    </div>
  );

  return (
    <div className="flex">
      <div className="w-1/4">
        <p className="font-bold">2. Define Success:</p>
      </div>
      <div className="w-full">
        {currentFile ? outer : <p>You first need to select the data!</p>}
        <Modal
          show={showModal}
          handleClose={() => setShowModal(false)}
          id="define-success"
          ariaLabel="define-success"
        >
          {inner}
        </Modal>
      </div>
    </div>
  );
};

export default SetSuccess;
